var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrilliantGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 21,
    viewBox: "0 0 73 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5986 19.3841V0.941291C28.5986 0.421178 29.0182 0 29.5358 0C30.053 0 30.4726 0.421178 30.4726 0.941291V19.3841C30.4726 19.9042 30.053 20.3254 29.5358 20.3254C29.0182 20.3254 28.5986 19.9042 28.5986 19.3841Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3496 19.3841V0.941291C32.3496 0.421178 32.7692 0 33.2868 0C33.8039 0 34.2236 0.421178 34.2236 0.941291V19.3841C34.2236 19.9042 33.8039 20.3254 33.2868 20.3254C32.7692 20.3254 32.3496 19.9042 32.3496 19.3841Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1006 19.2554V8.00841C36.1006 7.4883 36.5202 7.06665 37.0373 7.06665C37.5549 7.06665 37.9745 7.4883 37.9745 8.00841V19.2554C37.9745 19.7755 37.5549 20.1967 37.0373 20.1967C36.5202 20.1967 36.1006 19.7755 36.1006 19.2554Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8486 19.2554V8.00841C24.8486 7.4883 25.2682 7.06665 25.7854 7.06665C26.3029 7.06665 26.7226 7.4883 26.7226 8.00841V19.2554C26.7226 19.7755 26.3029 20.1967 25.7854 20.1967C25.2682 20.1967 24.8486 19.7755 24.8486 19.2554Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9189 6.56134V4.71032C68.9189 4.1902 69.3386 3.76855 69.8557 3.76855C70.3733 3.76855 70.7929 4.1902 70.7929 4.71032V6.56134H72.0123C72.4793 6.56134 72.912 6.8817 72.987 7.34481C73.0822 7.93464 72.6317 8.44439 72.0625 8.44439H70.7929V19.0756C70.7929 19.6476 70.2856 20.1003 69.6986 20.0047C69.2378 19.9293 68.9189 19.4944 68.9189 19.0252V8.44439V6.56134Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7202 13.5327C52.7202 9.96779 49.8335 7.06665 46.2854 7.06665C42.7368 7.06665 39.8506 9.96779 39.8506 13.5327C39.8506 17.0986 42.7368 19.9998 46.2854 19.9998C48.1195 19.9998 49.7726 19.2201 50.9456 17.9791V18.8568C50.9456 19.3496 51.3427 19.7482 51.8331 19.7482C52.3231 19.7482 52.7202 19.3496 52.7202 18.8568V13.9808C52.7202 13.9299 52.7136 13.8799 52.7052 13.8314C52.7099 13.732 52.7202 13.634 52.7202 13.5327ZM46.2849 18.2152C43.7152 18.2152 41.6246 16.114 41.6246 13.5318C41.6246 10.9501 43.7152 8.84936 46.2849 8.84936C48.8546 8.84936 50.9451 10.9501 50.9451 13.5318C50.9451 16.114 48.8546 18.2152 46.2849 18.2152Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4348 7.22223C4.60071 7.22223 2.94759 8.00145 1.77408 9.24285V0.891354C1.77408 0.399036 1.37698 0 0.887042 0C0.397106 0 0 0.399036 0 0.891354V13.2403C0 13.2916 0.00656373 13.3411 0.0150028 13.3901C0.0103144 13.4895 0 13.5875 0 13.6883C0 17.2542 2.88664 20.1549 6.4348 20.1549C9.98297 20.1549 12.8696 17.2542 12.8696 13.6883C12.8696 10.1229 9.98297 7.22223 6.4348 7.22223ZM6.4346 18.3726C3.86443 18.3726 1.77388 16.2714 1.77388 13.6892C1.77388 11.107 3.86443 9.00632 6.4346 9.00632C9.00477 9.00632 11.0953 11.107 11.0953 13.6892C11.0953 16.2714 9.00477 18.3726 6.4346 18.3726Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1603 19.0447V14.1036C56.1603 11.6444 58.0024 9.48526 60.445 9.32979C63.1052 9.16066 65.3228 11.2863 65.3228 13.9241V19.0447C65.3228 19.537 65.7199 19.9361 66.2099 19.9361C66.6998 19.9361 67.0974 19.537 67.0974 19.0447V14.1267C67.0974 10.6819 64.4691 7.70538 61.0447 7.54473C57.4032 7.37371 54.3857 10.3008 54.3857 13.9241V19.0447C54.3857 19.537 54.7833 19.9361 55.2733 19.9361C55.7632 19.9361 56.1603 19.537 56.1603 19.0447Z",
    fill: "#55595F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2091 7.52558C22.5818 7.26882 21.9062 7.10723 21.1931 7.07378C17.5511 6.90277 14.5342 9.83029 14.5342 13.4532V18.5737C14.5342 19.0665 14.9313 19.4656 15.4212 19.4656C15.9112 19.4656 16.3083 19.0665 16.3083 18.5737V13.6327C16.3083 11.1734 18.1503 9.01478 20.593 8.85931C21.5508 8.79807 22.4491 9.03834 23.2091 9.4892V7.52558Z",
    fill: "#55595F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrilliantGrey);
export default __webpack_public_path__ + "static/media/Brilliant_grey.fadf9aaada249fff06b9a68fa935f443.svg";
export { ForwardRef as ReactComponent };